<div class="preview-dialog">
  <div class="preview-header">
    <div class="preview-header-left">
      <span class="preview-title">Preview Logística</span>
      @if (contrato?.codigoTg) {
        <span class="preview-sub">{{ contrato.codigoTg }} — {{ contrato.nomeEvento || '-' }}</span>
      }
    </div>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-body">

    <!-- Contrato -->
    <div class="preview-section">
      <div class="section-title">
        <mat-icon class="section-icon">description</mat-icon>
        Contrato
      </div>
      <div class="fields-grid">
        <div class="field-item">
          <span class="field-label">Tg</span>
          <span class="field-value">{{ contrato?.codigoTg || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">{{ contrato?.nomeSubCliente ? 'Subcliente' : 'Cliente' }}</span>
          <span class="field-value">{{ contrato?.nomeSubCliente || contrato?.nomeCliente || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Consultor</span>
          <span class="field-value">{{ contrato?.nomeConsultor || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Status</span>
          <span class="field-value">{{ contrato?.statusDescricao || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Data Início</span>
          <span class="field-value">{{ contrato?.dataInicio || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Data Fim</span>
          <span class="field-value">{{ contrato?.dataFim || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Valor Total</span>
          <span class="field-value">{{ fmt(contrato?.valorTotal) }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Solicitante</span>
          <span class="field-value">{{ contrato?.solicitante || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Email do Solicitante</span>
          <span class="field-value">{{ contrato?.solicitanteEmail || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Telefone do Solicitante</span>
          <span class="field-value">{{ contrato?.solicitanteTelefone || '-' }}</span>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Consultor -->
    <div class="preview-section">
      <div class="section-title">
        <mat-icon class="section-icon">support_agent</mat-icon>
        Consultor Operacional
      </div>
      <div class="fields-grid">
        <div class="field-item">
          <span class="field-label">Nome</span>
          <span class="field-value">{{ consultor?.nome || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Email</span>
          <span class="field-value">{{ consultor?.email || '-' }}</span>
        </div>
        <div class="field-item">
          <span class="field-label">Telefone</span>
          <span class="field-value">{{ consultor?.telefone || '-' }}</span>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Logística (abas da planilha) -->
    @if (abas.length > 0) {
      <div class="preview-section">
        <div class="section-title">
          <mat-icon class="section-icon">directions_car</mat-icon>
          Logística
        </div>

        <mat-tab-group class="abas-tabs">
          @for (aba of abas; track aba.titulo) {
            <mat-tab [label]="aba.titulo">
              <div class="aba-content">
                <div class="aba-total">
                  <span>{{ aba.grupos?.length ?? 0 }} veículo(s)</span>
                  <span class="aba-total-valor">Total: {{ fmt(aba.total) }}</span>
                </div>

                @for (grupo of aba.grupos; track grupo.contratoItemId) {
                  <div class="item-card">
                    <div class="item-card-header">
                      @if (grupo.codigoOs) {
                        <span class="os-codigo">OS {{ grupo.codigoOs }}</span>
                      }
                      <span class="item-veiculo">{{ grupo.tipoVeiculo || '-' }}</span>
                      <span class="item-servico">{{ grupo.tipoServico || '-' }}</span>
                      <span class="item-pax">{{ grupo.passageiros?.length ?? 0 }} PAX</span>
                      <span class="grupo-valor">{{ fmt(grupo.valor) }}</span>
                    </div>
                    <div class="item-card-datas">
                      <span>Data: {{ grupo.data || '-' }}</span>
                      @if (grupo.motorista) {
                        <span>Motorista: {{ grupo.motorista }}{{ grupo.motoristaTelefone ? ' · ' + grupo.motoristaTelefone : '' }}</span>
                      }
                      @if (grupo.estacionamento) {
                        <span>Estacionamento: {{ grupo.estacionamento }}</span>
                      }
                    </div>
                    @if (grupo.origem || grupo.destino) {
                      <div class="item-card-rota">
                        <mat-icon class="rota-icon">trip_origin</mat-icon>
                        <span>{{ grupo.origem || '-' }}</span>
                        <mat-icon class="rota-icon">arrow_forward</mat-icon>
                        <mat-icon class="rota-icon">place</mat-icon>
                        <span>{{ grupo.destino || '-' }}</span>
                      </div>
                    }
                    @if (grupo.observacao) {
                      <div class="grupo-obs">{{ grupo.observacao }}</div>
                    }

                    @if (grupo.passageiros?.length > 0) {
                      <div class="pax-table-wrapper">
                        <table class="pax-table">
                          <thead>
                            <tr>
                              <th>Nome</th>
                              <th>Contato</th>
                              <th>Data</th>
                              @if (aba.mostrarVoo) {
                                <th>Voo</th>
                                <th>Hora Voo</th>
                              }
                              <th>Transfer</th>
                              @if (aba.mostrarEnderecoPax) {
                                <th>Origem</th>
                                <th>Destino</th>
                              }
                            </tr>
                          </thead>
                          <tbody>
                            @for (p of grupo.passageiros; track $index) {
                              <tr>
                                <td class="pax-nome">{{ p.nome || '-' }}</td>
                                <td>{{ p.contato || '-' }}</td>
                                <td>{{ p.data || '-' }}</td>
                                @if (aba.mostrarVoo) {
                                  <td>{{ vooInfo(p) }}</td>
                                  <td>{{ hora(p.horarioVoo) }}</td>
                                }
                                <td>{{ hora(p.horarioTransfer) }}</td>
                                @if (aba.mostrarEnderecoPax) {
                                  <td class="pax-endereco">{{ p.origem || '-' }}</td>
                                  <td class="pax-endereco">{{ p.destino || '-' }}</td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                  </div>
                }
              </div>
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    } @else {
    <!-- Itens (fallback quando o backend não envia "abas") -->
    <div class="preview-section">
      <div class="section-title">
        <mat-icon class="section-icon">directions_car</mat-icon>
        Itens ({{ itens.length }})
      </div>

      @if (itens.length === 0) {
        <p class="empty-text">Nenhum item de logística.</p>
      }

      @for (entry of itens; track entry.item?.id) {
        <div class="item-card">
          <div class="item-card-header">
            <span class="item-veiculo">{{ entry.item?.tipoVeiculoDescricao || '-' }}</span>
            <span class="item-servico">{{ entry.item?.servicoDescricao || '-' }} ({{ entry.item?.tipoServicoDescricao || '-' }})</span>
            <span class="item-pax">{{ entry.item?.quantidadePassageiro ?? 0 }} PAX</span>
            @if (entry.item?.temOs) {
              <span class="badge-os">com OS</span>
            }
          </div>
          <div class="item-card-rota">
            <mat-icon class="rota-icon">trip_origin</mat-icon>
            <span>{{ entry.item?.cidadeOrigem || '-' }}</span>
            <mat-icon class="rota-icon">arrow_forward</mat-icon>
            <mat-icon class="rota-icon">place</mat-icon>
            <span>{{ entry.item?.cidadeDestino || '-' }}</span>
            <span class="item-trecho">· {{ entry.item?.tipoTrechoDescricao || '-' }}</span>
          </div>
          <div class="item-card-datas">
            <span>Início: {{ entry.item?.dataInicio || '-' }} {{ entry.item?.horaInicio?.substring(0, 5) || '' }}</span>
            <span>Fim: {{ entry.item?.dataFinal || '-' }} {{ entry.item?.horaFinal?.substring(0, 5) || '' }}</span>
            <span>Valor c/ Taxa: {{ fmt(entry.item?.valorComTaxa) }}</span>
          </div>

          @if (entry.ordensServico?.length > 0) {
            <div class="os-list">
              @for (os of entry.ordensServico; track os.codigoOs) {
                <div class="os-card">
                  <div class="os-card-header">
                    <span class="os-codigo">OS {{ os.codigoOs || '-' }}</span>
                    <span class="os-data">{{ os.dataInicio || '-' }} {{ hora(os.horaInicio) }}</span>
                  </div>
                  @if (os.motorista) {
                    <div class="os-motorista">
                      <mat-icon class="rota-icon">badge</mat-icon>
                      {{ os.motorista?.nome || '-' }}
                    </div>
                  }

                  @if (os.gruposPassageiros?.length > 0) {
                    <mat-accordion class="pax-groups" multi="true">
                      @for (grupo of os.gruposPassageiros; track grupo.key) {
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <mat-icon class="rota-icon">trip_origin</mat-icon>
                              {{ endereco(grupo.sample, 'origem') }}
                              <mat-icon class="rota-icon">arrow_forward</mat-icon>
                              <mat-icon class="rota-icon">place</mat-icon>
                              {{ endereco(grupo.sample, 'destino') }}
                            </mat-panel-title>
                            <mat-panel-description>
                              {{ vooInfo(grupo.sample) }} · {{ grupo.sample.vooData || '-' }} {{ hora(grupo.sample.horaPartida) }} · {{ grupo.passageiros.length }} pax
                            </mat-panel-description>
                          </mat-expansion-panel-header>

                          <div class="pax-group-fields">
                            <div class="field-item">
                              <span class="field-label">Voo</span>
                              <span class="field-value">{{ vooInfo(grupo.sample) }}</span>
                            </div>
                            <div class="field-item">
                              <span class="field-label">Data/Hora Voo</span>
                              <span class="field-value">{{ grupo.sample.vooData || '-' }} {{ hora(grupo.sample.vooHora) }}</span>
                            </div>
                            <div class="field-item">
                              <span class="field-label">Hora Partida/Chegada</span>
                              <span class="field-value">{{ hora(grupo.sample.horaPartida) }} / {{ hora(grupo.sample.horaChegada) }}</span>
                            </div>
                          </div>

                          <div class="pax-group-body">
                            @for (p of grupo.passageiros; track p.passageiroId) {
                              <span class="pax-chip" [matTooltip]="(p.documento || '-') + ' · ' + (p.contato || '-')">{{ p.nome }}</span>
                            }
                          </div>
                        </mat-expansion-panel>
                      }
                    </mat-accordion>
                  }
                </div>
              }
            </div>
          }

          @if (entry.servicosAdicionais?.length > 0) {
            <div class="servicos-adicionais">
              @for (srv of entry.servicosAdicionais; track $index) {
                <span class="badge-servico">{{ srv.descricao || srv }}</span>
              }
            </div>
          }
        </div>
      }
    </div>
    }

    <mat-divider></mat-divider>

    <!-- Fechamento -->
    <div class="preview-section">
      <div class="section-title">
        <mat-icon class="section-icon">payments</mat-icon>
        Fechamento
      </div>

      @if (!fechamentoResumo) {
        <p class="empty-text">Sem dados de fechamento.</p>
      } @else {
        <div class="fields-grid">
          <div class="field-item">
            <span class="field-label">Período</span>
            <span class="field-value">{{ fechamentoResumo.periodoInicio || '-' }} — {{ fechamentoResumo.periodoFim || '-' }}</span>
          </div>
        </div>

        <div class="resumo-table">
          @for (trecho of fechamentoResumo.trechos; track $index) {
            <div class="resumo-row">
              <span>{{ trecho.tipoTrecho || '-' }}</span>
              <span>{{ fmt(trecho.valor) }}</span>
            </div>
          }
          <div class="resumo-row resumo-subtotal">
            <span>Subtotal Trechos</span>
            <span>{{ fmt(fechamentoResumo.subtotalTrechos) }}</span>
          </div>

          <div class="resumo-row">
            <span>Coordenação</span>
            <span>{{ fmt(fechamentoResumo.coordenacao) }}</span>
          </div>
          <div class="resumo-row">
            <span>Horas Adicionais</span>
            <span>{{ fmt(fechamentoResumo.horasAdicionais) }}</span>
          </div>
          <div class="resumo-row">
            <span>Estacionamento / Receptivo de Embarque</span>
            <span>{{ fmt(fechamentoResumo.estacionamentoReceptivoEmbarque) }}</span>
          </div>
          <div class="resumo-row">
            <span>Outros Serviços</span>
            <span>{{ fmt(fechamentoResumo.outrosServicos) }}</span>
          </div>
          <div class="resumo-row resumo-subtotal">
            <span>Subtotal Adicionais</span>
            <span>{{ fmt(fechamentoResumo.subtotalAdicionais) }}</span>
          </div>

          <div class="resumo-row">
            <span>Total</span>
            <span>{{ fmt(fechamentoResumo.total) }}</span>
          </div>
          <div class="resumo-row">
            <span>Taxa 5%</span>
            <span>{{ fmt(fechamentoResumo.taxa5) }}</span>
          </div>
          <div class="resumo-row resumo-total">
            <span>Total com Taxa</span>
            <span>{{ fmt(fechamentoResumo.totalComTaxa) }}</span>
          </div>
        </div>
      }
    </div>

    @if (coordenadores.length > 0) {
      <mat-divider></mat-divider>
      <div class="preview-section">
        <div class="section-title">
          <mat-icon class="section-icon">groups</mat-icon>
          Coordenadores ({{ coordenadores.length }})
        </div>
        <div class="coordenadores-list">
          @for (c of coordenadores; track c.id) {
            <div class="coordenador-card">
              <div class="coordenador-header">
                <span class="coordenador-nome">{{ c.nome || '-' }}</span>
              </div>
              <div class="fields-grid">
                <div class="field-item">
                  <span class="field-label">Trecho</span>
                  <span class="field-value">{{ c.tipoTrechoDescricao || '-' }}</span>
                </div>
                <div class="field-item">
                  <span class="field-label">Data do Serviço</span>
                  <span class="field-value">{{ c.dataServico || '-' }}</span>
                </div>
                <div class="field-item">
                  <span class="field-label">Hora</span>
                  <span class="field-value">{{ c.hora || '-' }}</span>
                </div>
                <div class="field-item">
                  <span class="field-label">Local</span>
                  <span class="field-value">{{ c.local || '-' }}</span>
                </div>
                <div class="field-item">
                  <span class="field-label">Contato</span>
                  <span class="field-value">{{ c.contato || '-' }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }

  </div>

  <div class="preview-footer">
    <button mat-button class="btn-tg-white" (click)="close()">Fechar</button>
  </div>
</div>
